(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvInflowQuizIds', function (vvLocalStorage) {
    var quizIds = [];
    var quizIdLoaded = false;

    var loadQuizIds = function() {
      if (!quizIdLoaded) {
        quizIds = vvLocalStorage.get('inflowQuizIds') || [];
        quizIdLoaded = true;
      }
    };

    this.getQuizIds = function() {
      loadQuizIds();
      return quizIds;
    };

    this.addQuizId = function(id) {
      loadQuizIds();
      if (quizIds.indexOf(id) >= 0) {
        return;
      }
      quizIds.push(id);
      vvLocalStorage.set('inflowQuizIds', quizIds);
    };

    this.isFirstInflow = function(id) {
      loadQuizIds();
      return quizIds.indexOf(id) < 0;
    };
  });
})(window, window.angular);
